<template>
  <v-card>
    <v-card-title>Dados Gerais</v-card-title>
    <v-card-text class="card-height">
      <v-layout row wrap form-padding>
        <v-flex md3 sm12>
          <v-text-field
            placeholder=" "
            readonly
            class="form-input-box"
            label="Tipo de Pessoa"
            v-model="taker.tipo_pessoa"
          />
        </v-flex>

        <v-flex md3 sm12>
          <v-text-field
            placeholder=" "
            readonly
            class="form-input-box"
            label="CNPJ do Tomador"
            :value="formatCNPJ(taker.cnpj_cpf)"
          />
        </v-flex>

        <v-flex md6 sm12>
          <v-text-field
            placeholder=" "
            readonly
            class="form-input-box"
            label="Razão Social"
            v-model="taker.nome"
          />
        </v-flex>
        <v-flex md3 sm12>
          <v-text-field
            class="form-input-box"
            :value="
              taker.endereco && taker.endereco.cep
                ? formatCEP(taker.endereco.cep)
                : 'Não Informado'
            "
            placeholder=" "
            readonly
            label="CEP"
          />
        </v-flex>
        <v-flex md9 sm12>
          <v-text-field
            class="form-input-box"
            placeholder=" "
            readonly
            :value="
              taker.endereco && taker.endereco.logradouro
                ? taker.endereco.logradouro
                : 'Não Informado'
            "
            label="Endereço"
          />
        </v-flex>
        <v-flex md4 sm12>
          <v-text-field
            class="form-input-box"
            placeholder=" "
            readonly
            :value="
              taker.endereco && taker.endereco.bairro
                ? taker.endereco.bairro
                : 'Não Informado'
            "
            label="Bairro"
          />
        </v-flex>
        <v-flex md4 sm12>
          <v-text-field
            class="form-input-box"
            placeholder=" "
            readonly
            :value="
              taker.endereco && taker.endereco.cidade
                ? taker.endereco.cidade
                : 'Não Informado'
            "
            label="Cidade"
          />
        </v-flex>
        <v-flex md4 sm12>
          <v-text-field
            class="form-input-box"
            placeholder=" "
            readonly
            :value="
              taker.endereco && taker.endereco.uf
                ? taker.endereco.uf
                : 'Não Informado'
            "
            label="UF"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script lang="js">
import { formatCNPJ, formatCEP } from "@/libs/utils";

export default {
  name: "TomadorDadosGerais",

  data() {
    return {
      formatCNPJ,
      formatCEP
    };
  },
  props: ["taker"],
};
</script>

<style lang="scss" scoped>
.v-card__title {
  background-color: #efefef;
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
  margin-bottom: 20px;
}

.card-height {
  max-height: 62vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// ./src/components/TomadorDadosGerais.vue